import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeBlogHtmlEmbed'
 * @name TypeBlogHtmlEmbedFields
 * @type {TypeBlogHtmlEmbedFields}
 * @memberof TypeBlogHtmlEmbed
 */
export interface TypeBlogHtmlEmbedFields {
    /**
     * Field type definition for field 'name' (Name)
     * @name Name
     * @localized false
     */
    name: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'url' (Url)
     * @name Url
     * @localized false
     */
    url: EntryFieldTypes.Text;
}

/**
 * Entry skeleton type definition for content type 'blogHtmlEmbed' (Blog Html Embed)
 * @name TypeBlogHtmlEmbedSkeleton
 * @type {TypeBlogHtmlEmbedSkeleton}
 * @author 3QfgNsR8Bna6Vwl54wI1fJ
 * @since 2025-10-21T22:25:33.574Z
 * @version 5
 */
export type TypeBlogHtmlEmbedSkeleton = EntrySkeletonType<TypeBlogHtmlEmbedFields, "blogHtmlEmbed">;
/**
 * Entry type definition for content type 'blogHtmlEmbed' (Blog Html Embed)
 * @name TypeBlogHtmlEmbed
 * @type {TypeBlogHtmlEmbed}
 * @author 3QfgNsR8Bna6Vwl54wI1fJ
 * @since 2025-10-21T22:25:33.574Z
 * @version 5
 */
export type TypeBlogHtmlEmbed<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeBlogHtmlEmbedSkeleton, Modifiers, Locales>;

export function isTypeBlogHtmlEmbed<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeBlogHtmlEmbed<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blogHtmlEmbed'
}
